export type NodeModel = {
  id: string;
  type: string;
  style?: {};
  connectable?: boolean;
  draggable: boolean;
  data: {
    label?: {};
    name: string;
    origin: string;
    recycleRate: number;
  };
  position: {
    x: number;
    y: number;
  };
};

export type EdgeModel = {
  id: string;
  source: string;
  target: string;
  type: string;
  label: string;
  style: {};
  labelStyle: {};
};

export type ConnectionTreeModel = {
  nodes: NodeModel[];
  edges: EdgeModel[];
};

export enum CONNECTION_TREE_QUERY {
  CERTIFICATE_TREE = 'CERTIFICATE_TREE',
}
